import React, { useState } from 'react';

import './dropdown.text.scss';
import {useTranslation} from "react-i18next";
import {DropDownLog} from "../../services/interactions/elements/dropdown";

function UsersDropdownText({options, label, placeholder, value, userActive, onChange, onClick, changeUserActive, transparent}){
    const [isOpen, setOpen] = useState(false);
    const currentValue = options.find(o => o.value === value);
    const {t} = useTranslation(['users'])

    const toggleOpen = () => {
        if (onClick) {
            onClick(!isOpen);
        }
        setOpen(!isOpen);
    }

    const _onChange = (option) => {
        onChange(option);
    }

    return (
        <div className={`_dropdownContainer ${isOpen ? 'open' : ''}`}>
            {
                isOpen ? <div className="_dropdownOverlay" onClick={toggleOpen}></div> : ''
            }
            <div className="_dropdown" onClick={toggleOpen}>
                <span className="material-icons">
                    filter_list
                </span>
                <span>
                    {t('filter')}
                </span>
                <p>
                    {!!currentValue && currentValue.label ? currentValue.label : ''}
                </p>
                <i className="material-icons">
                    keyboard_arrow_down
                </i>
            </div>
            <div className="_options">
                {
                    label ?
                    <p className="label">{label}</p>
                    : ''
                }
                {
                    options.map((option, index) => {
                        const selected = option.value === value;
                        return (
                            <div className={`_option ${selected ? 'selected' : ''}`} onClick={() => _onChange(option)} key={index}>
                                <div className="check">
                                    <i className="material-icons">
                                        check
                                    </i>
                                </div>
                                <p>
                                    {option.label}
                                </p>
                            </div>
                        )
                    })
                }
                <div className="divider" ></div>
                <div className={`_option ${!userActive ? 'selected' : ''}`} onClick={() => changeUserActive(userActive)}>
                    <div className="check">
                        <i className="material-icons">check</i>
                    </div>
                    <p>{t('show-inactive')}</p>
                </div>
            </div>
        </div>
    )
}

export default DropDownLog(UsersDropdownText);
